import * as types from "./types";

const mutations = {
    [types.LOADING_EMPLOYEE_TRAINING](state, value) {
        state.loading = value;
    },
    [types.GET_EMPLOYEE_TRAINING_LIST](state, employeeTrainings) {
        state.employeeTrainings = employeeTrainings;
    },
    [types.REMOVE_EMPLOYEE_TRAINING](state, id) {        
        state.employeeTrainings = state.employeeTrainings.filter((x) => x.id !== id);        
    },
    [types.ADD_EMPLOYEE_TRAINING](state, employeeTraining) {        
        state.employeeTrainings.unshift(employeeTraining);
    },
    [types.UPDATE_EMPLOYEE_TRAINING](state, employeeTraining) {        
        const employeeTrainingIndex = state.employeeTrainings.findIndex((x) => x.id === employeeTraining.id);
        state.employeeTrainings[employeeTrainingIndex] = employeeTraining;        
    },
    [types.GET_EMPLOYEE_TRAINING_BY_ID](state, employeeTrainingId) {
        state.employeeTrainingId = employeeTrainingId;
    }
};

export default mutations;